import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PermissionModel } from "../models/PermissionsModels/PermissionModel";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";



@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  ApiUrl = "/api/admin/Permissions/"
  constructor(private http: RequestHandlerService) {
  }

  Loaddropdowns() {
 
    return this.http.get( this.ApiUrl + 'Loaddropdowns');
  }
  AddPermission( AddModel: PermissionModel) {
    return this.http.post( this.ApiUrl + 'AddPermission', AddModel);
  }
  EditPermission(EditModel: PermissionModel) {
    return this.http.post( this.ApiUrl + 'EditPermission', EditModel);
  }
  DeletePermission( UsersIDRequestModel: UsersIDRequestModel) {
   
    return this.http.post( this.ApiUrl + 'DeletePermission', UsersIDRequestModel);
  }
  GetPermissionsByFilter(FilteredPermissionsRequestModel: any) {
  
    return this.http.post( this.ApiUrl + 'GetPermissionsByFilter', FilteredPermissionsRequestModel);
  }

}